<template>
  <div class="content">
    <div class="holder container">
      <div class="content-body col-md-7 col-11 p-0">
        <div class="form-group row-text-index">
          <span class="font-weight-bold">{{ $t("front_end.a080.order_number") }} : {{ realOrderNo }}</span>
        </div>
        <div class="form-group message-group">
          <p class="message">{{ $t("front_end.a120.message_first_shop") }}</p>
          <p class="message">{{ $t("front_end.a120.message_middle_shop") }}</p>
          <p class="message">{{ $t("front_end.a120.message_bottom_shop") }}</p>
        </div>
      </div>
      <div class="content-footer-payment" @click="redirectPage()">
        <button class="col-md-4 col-7 btn-footer">{{ $t("front_end.a080.button_go_back_top") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";


export default {
  name: "A120",
 
  async created() {
    localStorage.setItem("personal_address", "[]");
    //delete sessionStorage.ed
    sessionStorage.setItem("ed", "{}");
    this.$store.dispatch("userData/clearSession");
    this.$store.dispatch("reOrder/clearSession");
    this.$store.dispatch("userData/clearSessionReOrder");
    this.$store.dispatch("userData/clearSessionTemplate");

    this.realOrderNo = await this.getOrderNo();
  },
  computed: {
    orderNo() {
      return this.$route.params.orderNo;
    }
  },
  data() {
    return {
      realOrderNo:""
    };
  },
  head: {
    script: function() {
      return [
        {i: `// --------------------------------------------------
// Yahoo! コンバージョンタグ（年賀状お申し込み）
// 
// 以下のタグを『年賀状お申し込み完了ページ』の
// <head>内『サイトジェネラルタグの後』に設置してください
// --------------------------------------------------

ytag({
  "type":"yjad_conversion",
  "config":{
    "yahoo_ydn_conv_io": "${process.env.VUE_APP_YAHOO_CONV_ID}",
    "yahoo_ydn_conv_label": "${process.env.VUE_APP_YAHOO_CONV_LABEL}",
    "yahoo_ydn_conv_transaction_id": "${process.env.VUE_APP_YAHOO_CONV_TRAN_ID}",
    "yahoo_ydn_conv_value": "${process.env.VUE_APP_YAHOO_CONV_VALUE}"
  }
});`, async: true, body: false, },
      {i: `// --------------------------------------------------
// LINE コンバージョンコード
// 
// 以下のタグを『年賀状お申し込み完了ページ』の
// <head>内『ベースコード（先日設置いただいたコード）の後』に設置してください
// --------------------------------------------------
_lt('send', 'cv', {
  type: 'Conversion'
},['${process.env.VUE_APP_LINE_TAGID}']);`, body: false },
      ]
    }
  },
  methods: {
    confirmDownloadOrderSlip() {
      this.$refs.confirmDownloadOrderSlip.show();
    },
    redirectPage() {
      this.$router.push({ name: "a005" });
    },
    async getOrderNo(){
      let {data}  =  await apiService.post(apiEndpoints.getOrderNo, {
        orderNo: this.orderNo,
        settlementResult:"success"
      });
      let {orderNo} = data || {};
      return orderNo;
    }
  }
};
</script>
<style
  scoped
  src="../../assets/css/completePayment/completePayment.css"
></style>
